import styled from 'styled-components';
import { media } from '@shared/styles';

export const StyledErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: 16px;
  text-align: center;
  padding: 24px;

  h2 {
    color: ${({ theme }) => theme.colors.text};
    font-size: 1.5rem;
  }

  p {
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  button {
    padding: 10px 24px;
    background: ${({ theme }) => theme.colors.primary};
    color: white;
    border: none;
    border-radius: ${({ theme }) => theme.sizes.borderRadiusSmall};
    cursor: pointer;
    font-size: 1rem;
    font-family: ${({ theme }) => theme.fonts.primary};
    min-height: 44px;

    &:hover {
      opacity: 0.9;
    }
  }

  ${media.tablet} {
    min-height: 40vh;
    padding: 20px 16px;
    gap: 12px;

    h2 {
      font-size: 1.3rem;
    }

    button {
      padding: 10px 20px;
      font-size: 0.9rem;
    }
  }
`;
